export enum ConversationAttachmentType {
  Image = 1,
  Link = 2,
}

export enum ImgStatus {
  Generating = 1,
  Success = 2,
  GenerateFailed = 3,
  ImgSensitive = 4,
}

export interface AttachmentImage {
  url: string;
  width?: number;
  height?: number;
  desc?: string;
  status?: ImgStatus;
}

export interface AttachmentLink {
  url: string;
  title?: string;
  desc?: string;
  full_content?: string;
}

export enum AttachmentVerifyResult {
  Passed = 1,
  Rejectd = 2,
}

export enum AttachmentExtractResult {
  Passed = 1,
  SecurityRejected = 2,
  ContentRejected = 3,
  OtherReasonRejected = 4,
}

export interface IPageQueryNpcIDByLastMsgTimeReq {
  page?: number;
  size?: number;
}

export interface IRecentlyChatNpcData {
  npc_id?: number;
  npc_name?: string;
  thumbnail_avatar_url?: string; // 缩略图头像链接
  last_msg_time?: number;
}

export interface IPageQueryNpcByLastMsgTimeResp {
  chat_npc_data_list?: IRecentlyChatNpcData[];
  has_more?: boolean;
}

export interface IGetVoiceReq {
  npc_id: number;
  im_mid?: string;
  custom_mid?: string;
  from_workspace?: boolean;
}

export interface IGetVoiceResp {
  voice_uri: string;
  voice_duration_ms: string;
}

export interface IRestartConversationReq {
  npc_id: number;
  from_workspace?: boolean;
}

export interface IVerifyConversationAttachmentResp {
  result: AttachmentVerifyResult;
  reject_desc: string;
}

export interface IVerifyConversationAttachmentReq {
  attachment_type: ConversationAttachmentType;
  image?: AttachmentImage;
  link?: AttachmentLink;
  npc_id: number;
  from_workspace?: boolean;
}

export interface IVerifyConversationExtractReq {
  attachment_type: ConversationAttachmentType;
  image?: AttachmentImage;
  link?: AttachmentLink;
  npc_id: number;
  from_workspace?: boolean;
}

export interface IVerifyConversationExtractResp {
  result: AttachmentExtractResult;
  reject_desc?: string;
  link_desc?: string;
  link_title?: string;
  image_desc?: string;
}

export interface IAsrReq {
  speech_audio_url?: string;
  client_asr_text?: string;
  speech_audio_data?: string;
}

export interface IAsrResp {
  asr_text?: string;
}

export enum CallScene {
  UserCallNpc = 1, // 用户主动呼叫npc
  NpcCallUser = 2, // npc主动呼叫用户
}

export enum EncodingType {
  Hex = 1,
  Base64 = 2,
}

export enum ChunkRespType {
  UserSendMsgText = 1, // asr文本
  ReplyMsgText = 2, // 回复文本
  ReplyMsgAudio = 3, // 回复音频流
  VoiceMsg = 4, // 回复音频消息
  BaseResp = 100,
}

export interface VoiceChatRespChunk {
  resp_type?: ChunkRespType;
  chunk_index?: number; // 各类型各自维护，从0开始
  finish?: boolean; // 各类型各自维护
  data?: VoiceChatRespChunkData;
  sensitive_reply?: boolean; // 敏感回复，用于标识
  send_timestamp?: number; // 发送时间戳
}

export interface VoiceChatRespChunkData {
  // 文本结果
  msg_text?: string;
  msg_audio_text?: string; // reply_msg类型中会有
  // 音频结果
  msg_audio?: string; // 编码音频数据
  chunk_secondary_index?: number; // 二级索引index，部分ChunkRespType类型下有值，如ReplyMsgAudio
  secondary_finish?: boolean;
  encoding_type?: EncodingType;
  msg_voice_url?: string;
}

export interface IVoiceChatReq {
  npc_id?: number;
  im_mid?: string; // deprecated: 仿照原文本聊天链路的环信mid，用于唯一标识msg
  voice_msg_url?: string; // 使用/weaver/api/v1/npc_editor/presigned_upload_url上传的语音文件
  voice_msg_data?: string; // base64编码音频流
  voice_msg_text?: string; // 语音消息文本内容
  voice_call_id?: number;
  enable_auto_deduct?: boolean; // 是否开启自动扣费
  scene?: CallScene;
  voice_chat_mode?: string; // 聊天模式
  user_msg_text?: string; // 用户打字输入的文本内容
  specify_npc_settings?: string; // 指定npc设置
  send_timestamp?: number; // 客户端req发送时间戳，用于统计网络耗时
  from_workspace?: boolean;
}

export interface IVoiceChatResp {
  chunk?: VoiceChatRespChunk;
  cid?: number;
  voice_call_id?: number;
  deduct_voice_call_balance_resp?: any; // 需要根据实际的wallet类型定义调整
  custom_mid?: string; // 自定义mid，用于标识自定义消息
}
